// extracted by mini-css-extract-plugin
export default {"wrapper":"contact-module--wrapper--z-MxP","input_form":"contact-module--input_form--YJNZg"};